import { TranslatePipe } from "@ngx-translate/core";
import { AngularSvgIconModule } from "angular-svg-icon";

import { ChangeDetectionStrategy, Component, inject, input } from "@angular/core";

import { MessageService } from "../../../services/messageservice";

@Component({
  selector: "timeline-footer",
  templateUrl: "timeline-footer.html",
  styleUrls: ["timeline-footer.scss"],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [AngularSvgIconModule, TranslatePipe],
})
export class TimelineFooterComponent {
  private msgsrv = inject(MessageService);

  protected showEmptyState = input.required<boolean>();
  protected hasMoreResults = input.required<boolean>();

  protected loadMore() {
    this.msgsrv.setMalfunctionLoadMore();
  }
}
